import {WebPageComponent } from "../components/webMain"



export const WebPage = () => {
    return (
       <WebPageComponent/>
    )
}